
// export const payloadValidator = (file) => {
//     const allowedDocTypes = [
//         'application/pdf', // PDF
//         'application/msword', // .doc (older Word)
//         'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//         'application/vnd.ms-excel', // .xls (older 
//         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx (new Excel)
//     ];

//     const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'];

//     const allowedSize = 3.2 * 1024 * 1024;
//     const hasInvisibleChars = /[\u200B-\u200F\u202A-\u202E\u2066-\u2069]/.test(file?.name);
//     const hasInvalidSpecialChars = /[^\w\d\-_~,;\[\]\(\).]/.test(file?.name);

//     const hasSpaces = /\s/.test(file?.name);

//     if (hasInvisibleChars) return { isValid: false, message: 'The file name contains invisible or invalid Unicode characters.' };
//     // if (hasSpaces) return { isValid: false, message: 'Spaces are not allowed in the file name.' }
//     if (hasInvalidSpecialChars) return { isValid: false, message: 'The file name contains special characters that are not allowed.' };
//     if (!file) return { isValid: false, message: 'File is required' };

//     if (allowedDocTypes.includes(file?.type)) {
//         if (file?.size <= allowedSize) return { isValid: true };
//         else return { isValid: false, message: 'File size exceeds 3MB limit.' };
//     } else if (allowedImageTypes.includes(file?.type)) {
//         if (file?.size <= allowedSize) return { isValid: true };
//         else return { isValid: false, message: 'File size exceeds 3MB limit.' };
//     } else {
//         return { isValid: false, message: 'Invalid file type' };
//     }
// }


const sanitizeFileName = (fileName) => {
    const lastDot = fileName.lastIndexOf('.');
    const name = lastDot !== -1 ? fileName.substring(0, lastDot) : fileName;
    const ext = lastDot !== -1 ? fileName.substring(lastDot) : '';

    const sanitized = name
        .replace(/[\u200B-\u200F\u202A-\u202E\u2066-\u2069]/g, '') // remove invisible unicode
        .replace(/[^a-zA-Z0-9_]/g, '_')                             // ✅ only letters, numbers, underscore
        .replace(/_+/g, '_')                                         // collapse multiple underscores
        .replace(/^_|_$/g, '');                                      // trim leading/trailing underscores

    return sanitized + ext;
};

export const payloadValidator = (file) => {
    const allowedDocTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];

    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'];

    const allowedSize = 3.2 * 1024 * 1024;

    if (!file) return { isValid: false, message: 'File is required' };
    console.log('Original file:', file);
    // Auto-rename: sanitize file name and return a new File object
    const sanitizedName = sanitizeFileName(file.name);
    const renamedFile = new File([file], sanitizedName, { type: file.type });

    if (allowedDocTypes.includes(file.type) || allowedImageTypes.includes(file.type)) {
        console.log('Renamed file:', renamedFile);
        if (file.size <= allowedSize) {
            return { isValid: true, file: renamedFile };
        } else {
            return { isValid: false, message: 'File size exceeds 3MB limit.' };
        }
    }

    return { isValid: false, message: 'Invalid file type' };
};